const SCRIPT_PATTERN = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
const EVENT_HANDLER_PATTERN = /\bon\w+\s*=\s*(['"]?)[^'"]*\1/gi;
const DANGEROUS_TAGS = /<\s*\/?\s*(script|iframe|object|embed|link|style|meta|base)\b[^>]*>/gi;
const JAVASCRIPT_URL = /javascript\s*:/gi;

export function sanitize(value: string): string {
  return value
    .replace(SCRIPT_PATTERN, '')
    .replace(DANGEROUS_TAGS, '')
    .replace(EVENT_HANDLER_PATTERN, '')
    .replace(JAVASCRIPT_URL, '');
}
